import { render, staticRenderFns } from "./GeofencingLimitations.vue?vue&type=template&id=60946016"
import script from "./GeofencingLimitations.vue?vue&type=script&lang=js"
export * from "./GeofencingLimitations.vue?vue&type=script&lang=js"
import style0 from "./GeofencingLimitations.vue?vue&type=style&index=0&id=60946016&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports